module.exports = __webpack_public_path__ + "static/media/16UNODC18.954be4e2.jpg";